module.exports = __webpack_public_path__ + "static/media/to.92f85475.svg";